/** Constantes de producto Fit Live (no son datos mock de negocio). */

export const DISCIPLINES = [
  { id: 'fuerza', label: 'Fuerza' },
  { id: 'pilates', label: 'Pilates' },
  { id: 'yoga', label: 'Yoga' },
  { id: 'hiit', label: 'HIIT' },
  { id: 'funcional', label: 'Funcional' },
  { id: 'cardio', label: 'Cardio' },
  { id: 'ciclismo', label: 'Ciclismo' },
  { id: 'extension', label: 'Extensión' },
];

export const WEEKDAY_LABELS = ['Dom', 'Lun', 'Mar', 'Mié', 'Jue', 'Vie', 'Sáb'];
